import generateConstantLifecycle from 'utils/generateConstantLifecycle';

// action type constants
export const DELETE_SESSION = 'DELETE_SESSION';
export const READ_USER_PROFILE = 'READ_USER_PROFILE';
export const READ_USER_SESSION = 'READ_USER_SESSION';
export const REMOVE_NEXT_ROUTE_LOCATION = 'REMOVE_NEXT_ROUTE_LOCATION';
export const SET_NEXT_ROUTE_LOCATION = 'SET_NEXT_ROUTE_LOCATION';

export const userConstants = {
  ...generateConstantLifecycle(
    DELETE_SESSION,
    READ_USER_SESSION,
    READ_USER_PROFILE,
  ),
  REMOVE_NEXT_ROUTE_LOCATION,
  SET_NEXT_ROUTE_LOCATION,
};
